import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

class FeluviraCartPlans extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.addEventListener('submit', this.submit, { signal: this.abort.signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, this.cartUpdated, { signal: this.abort.signal });
    window.addEventListener('pageshow', this.pageRestored, { signal: this.abort.signal });
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.refreshAbort?.abort();
  }
  pageRestored = event => { if (event.persisted) this.refresh(); };
  cartUpdated = event => {
    this.setAttribute('aria-busy', 'true');
    this.querySelector('[data-fva-refresh-status]').textContent = this.dataset.loading;
    if (event.promise) event.promise.then(() => this.refresh(), () => this.refresh());
    else this.refresh();
  };
  refresh = async () => {
    this.refreshAbort?.abort();
    const controller = this.refreshAbort = new AbortController();
    this.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(this.dataset.refreshUrl, { signal: controller.signal, headers: { Accept: 'text/html' }, cache: 'no-store' });
      if (!response.ok) throw new Error();
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('feluvira-cart-plans [data-fva-content]');
      if (!fresh) throw new Error();
      this.querySelector('[data-fva-content]').replaceWith(fresh);
      this.querySelector('[data-fva-refresh-status]').textContent = '';
      this.removeAttribute('aria-busy');
    } catch (error) {
      if (error.name === 'AbortError') return;
      this.querySelector('[data-fva-refresh-status]').textContent = this.dataset.refreshError;
    }
  };
  submit = async event => {
    const form = event.target.closest('[data-fva-plan-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled || this.hasAttribute('aria-busy')) return;
    const selected = form.elements.selling_plan.selectedOptions[0];
    const plan = selected.value ? Number(selected.value) : null;
    const quantity = Number(selected.dataset.quantity);
    const status = form.querySelector('[data-fva-status]');
    button.disabled = true;
    status.textContent = '';
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    try {
      this.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [{ merchandiseId: form.querySelector('[data-fva-variant]').value, quantity }], promise: deferred.promise, detail: { source: 'feluvira-cart-plan', sellingPlanId: plan } }));
      const response = await fetch(`${this.dataset.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: form.elements.id.value, quantity, selling_plan: plan }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.dataset.planError);
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(result), userErrors: [], warnings: [], detail: { items: result.items, didError: false, source: 'feluvira-cart-plan' } });
      window.location.reload();
    } catch (error) {
      deferred.reject(error);
      status.textContent = error.message || this.dataset.planError;
      button.disabled = false;
    }
  };
}
if (!customElements.get('feluvira-cart-plans')) customElements.define('feluvira-cart-plans', FeluviraCartPlans);
